import http from '@/utils/http'

/**
 * 摄像头分页列表
*/
export function cameraList(params) {
    return http({
        method: 'get',
        url: '/system/xcwsCamera/paging',
        params
    })
}

/**
 * TOB摄像头列表
*/
export function tobCameraList(params) {
  return http({
      method: 'get',
      url: '/system/xcwsCamera/tobCameraList',
      params
  })
}

/**
 * TOG摄像头列表
*/
export function togCameraList(params) {
  return http({
      method: 'get',
      url: '/system/xcwsCamera/togCameraList',
      params
  })
}

/**
 * 添加摄像头
*/
export function cameraAdd(data) {
  return http({
      method: 'post',
      url: '/system/xcwsCamera/add',
      data
  })
}

/**
 * 批量添加摄像头
*/
export function cameraBatchAdd(data) {
  return http({
      method: 'post',
      url: '/system/xcwsCamera/addBatch',
      data
  })
}

/**
 * 编辑摄像头
*/
export function cameraUpdate(data) {
  return http({
      method: 'post',
      url: '/system/xcwsCamera/update',
      data
  })
}

/**
 * 传封面
*/
export function coverUpdate(data) {
  return http({
      method: 'post',
      url: '/system/xcwsCamera/updateCoverUrl',
      params: data
  })
}

/**
 * 批量删除
*/
export function batchDel(data) {
  return http({
      method: 'post',
      url: '/system/xcwsCamera/deleteBatch',
      data
  })
}

/**
 * 批量禁用
*/
export function batchDisable(data) {
  return http({
      method: 'post',
      url: '/system/xcwsCamera/disableBatch',
      data
  })
}

/**
 * 批量启用
*/
export function batchEnable(data) {
  return http({
      method: 'post',
      url: '/system/xcwsCamera/enableBatch',
      data
  })
}